import { InventoryTree } from '@scaleaq/sitecontrol-lib';

/**
 * Recursively searches for an InventoryTree node by its name.
 * @param sourceName
 * @param nodes
 * @return The InventoryTree node with the matching name, or undefined if not found.
 */
export const findIdForNameInInventoryTree = (
  sourceName: string,
  nodes: InventoryTree[]
): InventoryTree | undefined => {
  for (const node of nodes) {
    if (node.name === sourceName) return node;
    const found = node.inventories && findIdForNameInInventoryTree(sourceName, node.inventories);
    if (found) return found;
  }
  return undefined;
};
